export default {
  defaultUserCookie: {
    essential: 1,
    performance: 0,
  },
  defaultPersonalised: {
    recommendations: 0,
  },
};

export const getSettingList = (t: any) => {
  return {
    CookiesSettingList: [
      {
        key: "essential",
        title: t("cookie.essential"),
        content: t("cookie.essentialDescription"),
        isControl: false,
      },
      {
        key: "performance",
        title: t("cookie.performance"),
        content: t("cookie.performanceDescription"),
        isControl: true,
      },
    ],
    PersonalisedSettingList: [
      {
        key: "recommendations",
        title: t("personalised.personalisedRecommendations"),
        content: t("personalised.recommendationsDescription"),
        isControl: true
      },
    ]
  }
}